import * as metadata from 'Flow2/containers/Masterdata/Masterdata';
import * as Controls from 'Flow2/config/Controls';


class Limit {
    
    static OBJECT_TYPE_CLIP = "OBJECT_TYPE_CLIP";
    static OBJECT_TYPE_USER = "OBJECT_TYPE_USER";
    static OBJECT_TYPE_ROOM = "OBJECT_TYPE_ROOM";
    
    static isLimited(type, props) {
        if(!props.limits || !props.limits[type]) {
            return false;
        }
        
        return props.limits[type].getIslimited();
    }
	
	static getUsage(type, props) {
        if(!props.limits || !props.limits[type]) {
            return false;
        }
		
		if(props.limits[type].getCurrent() < 1) {
			return 100;
		}
		
		return Math.round(props.limits[type].getCurrent() * 100 / props.limits[type].getLimit());
    }
}

export default Limit;

